export default __webpack_public_path__ + "static/media/markerloc.f9a45002.png";